
export default function AddTypePresetsDialogController(
  $q,
  $rootScope,
  $scope,
  alerts,
  assetDataService,
  loaderService,
  ssDialogService
) {
  const vm = this;
  vm.namePrefix = angular.copy(vm.asset.presetsNamePrefix);

  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleFormSubmit = _handleFormSubmit;

  /** *********************************************
   * Event Handlers
   */

  function _handleCloseDialog($event) {
    _closeDialog($event);
  }

  function _handleFormSubmit() {
    if ($scope.typePresetsForm.$valid) {
      loaderService.showViewLoader = true;
      assetDataService.createTypePresets(vm.asset.customerAssetId, vm.namePrefix).then(() => {
        vm.asset.presetsNamePrefix = vm.namePrefix;
        alerts.success('The Risk and Control presets have been successfully created.');
        $rootScope.$broadcast('refreshAssetRisks', { asset: vm.asset });
        ssDialogService.hide(ssDialogService.dialogs.assetAdmin.addTypePresetsDialog);
        loaderService.showViewLoader = false;
      });
    }
  }
  /** *********************************************
   * Private Functions
   */

  function _closeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.assetAdmin.addTypePresetsDialog);
  }
}

AddTypePresetsDialogController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'alerts',
  'assetDataService',
  'loaderService',
  'ssDialogService'
];
